export const useIncludedScripts = (pathname: string, includedPaths: string[] = []) =>
  includedPaths.some((path) => path === pathname);
